import React from 'react'
import { Navigate, Route } from 'react-router-dom'

import { LoaderProgress } from '@affstore-ds/uikit'

import { PageStaticStack } from '../../shared/components/PageStaticStack'
import { routes } from '../../shared/routes'
import { lazyLoadPageWithRetry } from '../../shared/utils/lazyLoadPageWithRetry'

import { useIsPostbacksEnabledQuery } from './base/hooks/useIsPostbacksEnabledQuery'

const PostbacksList = lazyLoadPageWithRetry(() => import('./list'))
const PostbacksCreate = lazyLoadPageWithRetry(() => import('./create'))
const PostbacksEdit = lazyLoadPageWithRetry(() => import('./edit'))
const PostbacksInfo = lazyLoadPageWithRetry(() => import('./info'))
const PostbacksTelegram = lazyLoadPageWithRetry(() => import('./telegram'))
const PostbacksTelegramCreate = lazyLoadPageWithRetry(() => import('./telegram/create'))
const PostbacksTelegramEdit = lazyLoadPageWithRetry(() => import('./telegram/edit'))

export const renderPostbacks = () => {
  const { data: isPostbacksEnabled, isLoading, isTelegramPostbacksEnabled } = useIsPostbacksEnabledQuery() // eslint-disable-line react-hooks/rules-of-hooks -- TODO: TASK-https://mbt.tpondemand.com/entity/394724-fe-remove-react-hook-from-function

  if (isLoading) {
    return (
      <Route
        element={
          <PageStaticStack>
            <LoaderProgress loading={isLoading} timeoutInterval={500} isFixed />
          </PageStaticStack>
        }
        path={routes.ROUTES_POSTBACKS.postbacksAll}
      />
    )
  }

  return (
    <>
      {isPostbacksEnabled ? (
        <Route>
          <Route element={<Navigate to={routes.ROUTES_POSTBACKS.postbacksList} />} path={routes.ROUTES_POSTBACKS.postbacksInfo} />
          <Route element={<PostbacksList />} path={routes.ROUTES_POSTBACKS.postbacksList} />
          <Route element={<PostbacksCreate />} path={routes.ROUTES_POSTBACKS.postbacksCreate} />
          <Route element={<PostbacksEdit />} path={routes.ROUTES_POSTBACKS.postbacksEditId} />
          {isTelegramPostbacksEnabled ? (
            <>
              <Route element={<PostbacksTelegram />} path={routes.ROUTES_POSTBACKS.postbacksTelegram} />
              <Route element={<PostbacksTelegramEdit />} path={routes.ROUTES_POSTBACKS.postbacksTelegramEdit} />
              <Route element={<PostbacksTelegramCreate />} path={routes.ROUTES_POSTBACKS.postbacksTelegramCreate} />
            </>
          ) : null}
        </Route>
      ) : (
        <Route>
          <Route element={<Navigate to={routes.ROUTES_POSTBACKS.postbacksInfo} />} path={routes.ROUTES_POSTBACKS.postbacksAll} />
          <Route element={<PostbacksInfo />} path={routes.ROUTES_POSTBACKS.postbacksInfo} />
        </Route>
      )}
    </>
  )
}
